import {
  deleteFromLocalStorage,
  getFromLocalStorage,
  setToLocalStorage,
} from '../../global/helpers';
import { SUPPORT_DEEP_LINK_KEY, SUPPORT_DEEP_LINK_TTL_MS } from './constants';

/** Имя query-параметра в ссылке, которую техподдержка отправляет ФЦ в WhatsApp. */
const SUPPORT_DEEP_LINK_PARAM = 'tickets';

/**
 * Запоминает переход по ссылке `?tickets=true` и убирает параметр из адресной
 * строки, чтобы перезагрузка страницы не открывала модалку повторно.
 *
 * Вызывается синхронно в `index.tsx` до `ReactDOM.render`: эффекты дочерних
 * компонентов выполняются раньше родительских, поэтому `<Redirect>` из
 * `InitComponent` успел бы переписать URL до любого `useEffect` внутри `App`.
 */
export const captureSupportDeepLink = (): void => {
  const params = new URLSearchParams(window.location.search);

  if (params.get(SUPPORT_DEEP_LINK_PARAM) !== 'true') {
    return;
  }

  setToLocalStorage(SUPPORT_DEEP_LINK_KEY, Date.now());

  params.delete(SUPPORT_DEEP_LINK_PARAM);
  const search = params.toString();
  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${search ? `?${search}` : ''}${
      window.location.hash
    }`
  );
};

/**
 * Считывает метку перехода и сразу её удаляет — в том числе когда модалку
 * открывать не нужно (у аптеки нет тега на тикеты), иначе метка залипнет
 * до следующего перехода по ссылке.
 *
 * @returns true, если переход был и метка не протухла по TTL.
 */
export const consumeSupportDeepLink = (): boolean => {
  const requestedAt = getFromLocalStorage(SUPPORT_DEEP_LINK_KEY);

  if (typeof requestedAt !== 'number') {
    return false;
  }

  deleteFromLocalStorage(SUPPORT_DEEP_LINK_KEY);

  return Date.now() - requestedAt < SUPPORT_DEEP_LINK_TTL_MS;
};
